import React, { useState } from "react";
import { Global } from "../helpers/Global";

export const FingerprintCheckerJornadas = () => {
    const [resultado, setResultado] = useState(null);
    const [cargando, setCargando] = useState(false);

    const verificarDuplicados = async () => {
        setCargando(true);
        setResultado(null);

        try {
            const response = await fetch(`${Global.url}jornadas/verificar-fingerprints`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setResultado(data);
            } else {
                setResultado({ message: "Error al comprobar fingerprints." });
            }
        } catch (error) {
            console.error("Error al verificar fingerprints:", error);
            setResultado({ message: "No se pudo conectar con el servidor." });
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="fingerprint-checker">
            <h2>Comprobador de Fingerprints en Jornadas</h2>
            <button onClick={verificarDuplicados} disabled={cargando}>
                {cargando ? "Comprobando..." : "Verificar Fingerprints Duplicados"}
            </button>

            {resultado && (
                <div className="resultado">
                    {resultado.duplicados?.length > 0 ? (
                        <div>
                            <h3>⚠️ Se encontraron fingerprints duplicados:</h3>
                            <ul>
                                {resultado.duplicados.map((item, index) => (
                                    <li key={index}>
                                        <strong>Fingerprint:</strong> {item.fingerprint} <br />
                                        <strong>Usuarios:</strong> {item.usuarios.join(", ")}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <p>✅ {resultado.message || "No hay fingerprints duplicados entre distintos usuarios."}</p>
                    )}
                </div>
            )}
        </div>
    );
};
